import { Component } from '@angular/core';
/*
  ErrorDialogComponent displays an error message in a dialog.
  Place this file at: src/app/components/error-dialog/error-dialog.component.ts
*/

@Component({
  selector: 'app-error-dialog',
  template: `
    <div class="error-dialog">
      <p>
        A new version of the application is available. Please refresh to update.
      </p>
      <button (click)="reloadPage()">Refresh</button>
    </div>
  `,
  styles: [
    `
      .error-dialog {
        text-align: center;
        padding: 15px;
      }
      .error-dialog p {
        font-size: 14px;
        margin-bottom: 20px;
      }
      .error-dialog button {
        background: #1a475a;
        color: #fff;
        border-radius: 5px;
        padding: 5px 10px;
        font-size: 14px;
      }
    `,
  ],
})
export class ErrorDialogComponent {
  reloadPage(): void {
    window.location.reload();
  }
}
